import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ReleaseState, StoreState } from "@type/models/store";
import { CloseOutlined, DownOutlined, UpOutlined } from "@ant-design/icons";
import { DefaultButton } from "../../../components/widgets";
import UploadTrack from "./upload-track";
import Tracks from "../tracks";
import { REACT_IMAGE_URL } from "../../../constants";
const { v4: uuidv4 } = require("uuid");

interface Props {
  handleSubmission: (field: string, data: any) => void;
  callFunction: boolean;
  clearForm: boolean;
}

const getLocalStorageData = () => {
  const storedData = localStorage.getItem("discData");
  return storedData ? JSON.parse(storedData) : [];
};

const TabSelectTrack: React.FC<Props> = ({
  handleSubmission,
  callFunction,
  clearForm,
}) => {
  const { select_tracks } = useSelector(
    (state: StoreState) => state.selectTrack
  );
  const { releaseInfo } = useSelector(
    (state: ReleaseState) => state.releaseInfo
  );
  const { tracklist } = useSelector((state: StoreState) => state.suggestion);
  const dispatch = useDispatch();
  const [data, setData] = useState<any>([]);
  const [selectedImage, setSelectedImage] = useState<string | null>(null);
  const [isEditingDiscNames, setIsEditingDiscNames] = useState<number | null>(
    null
  );

  const handleEditDiscName = (index: number) => {
    setIsEditingDiscNames(index);
  };

  const handleSaveDiscName = () => {
    setIsEditingDiscNames(null);
    setData([...data]);
  };

  const collectTracksFromSelectTracks = (discId: number) => {
    const filteredTracks = select_tracks.filter(
      (track) => track.idsexist === discId
    );
    const collectedData = filteredTracks.map((track) => {
      const matchingTrack = tracklist.list.find((item) => item.id === track.id);
      return matchingTrack;
    });
    return collectedData;
  };

  const addExistingTrack = (discId: any) => {
    let collectedData = collectTracksFromSelectTracks(discId);
    if (collectedData.length > 0) {
      const existingTrackIds =
        data
          .find((disc: any) => disc.id === discId)
          ?.tracks.map((track: any) => track.id) || [];

      const newTracks = collectedData.filter(
        (track: any) => !existingTrackIds.includes(track.id)
      );

      const updatedData = data.map((disc: any) => {
        if (disc.id === discId && newTracks.length > 0) {
          disc.tracks.push(...newTracks);
        }
        return disc;
      });

      setData(updatedData);
      dispatch({
        type: "SET_SELECT_TRACKS",
        payload: [],
      });
    }
  };

  const handleTrackDelete = (discid: number, trackid: number) => {
    const discIndex = data.findIndex((disc: any) => disc.id === discid);
    if (discIndex !== -1) {
      const trackIndex = data[discIndex].tracks.findIndex(
        (track: any) => track.id === trackid
      );
      if (trackIndex !== -1) {
        data[discIndex].tracks.splice(trackIndex, 1);
        setData([...data]);
      }
    }
  };

  const moveItemUp = (discId: number) => {
    const discIndex = data.findIndex((disc: any) => disc.id === discId);
    if (discIndex > 0) {
      const updatedData = [...data];
      [updatedData[discIndex], updatedData[discIndex - 1]] = [
        updatedData[discIndex - 1],
        updatedData[discIndex],
      ];
      setData(updatedData);
    }
  };

  const moveItemDown = (discId: number) => {
    const discIndex = data.findIndex((disc: any) => disc.id === discId);
    if (discIndex < data.length - 1) {
      const updatedData = [...data];
      [updatedData[discIndex], updatedData[discIndex + 1]] = [
        updatedData[discIndex + 1],
        updatedData[discIndex],
      ];
      setData(updatedData);
    }
  };

  const handleImageUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e: ProgressEvent<FileReader>) => {
        if (e.target && typeof e.target.result === "string") {
          setSelectedImage(e.target.result);
        }
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSubmit = () => {
    handleSubmission("discs", data);
  };

  useEffect(() => {
    if (callFunction) {
      handleSubmit();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [callFunction]);

  useEffect(() => {
    setData([]);
  }, [clearForm]);

  useEffect(() => {
    setData(getLocalStorageData());
  }, []);

  useEffect(() => {
    if (releaseInfo?.discs?.length) {
      setData(releaseInfo.discs);
    }
  }, [releaseInfo]);

  return (
    <div className="min-h-[300px] flex flex-col space-y-2 sm:flex-row sm:flex-wrap sm:-mx-4">
      <div className="text-center tw-flex tw-flex-col tw-space-y-2 p-4 ">
        {data?.map((item: any, index: number) => {
          let item_id: any = item.id;
          return (
            <div
              key={index}
              className=" tw-flex tw-flex-col tw-space-y-2  tw-py-7  "
              style={{ border: "1.5px dashed black" }}
            >
              <div className="flex ">
                <div className=" col-12 col-md-6 tw-flex tw-flex-col tw-space-y-2  ">
                  <div className="tw-w-full flex tw-text-md  ">
                    <img
                      src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSxmLznDRP3ZeNqcqtS1ndEFhJKfft2Ko5JLWbFkqMZyieeftoLDY-xam7Q20cm9H3buVc&usqp=CAU"
                      alt=""
                      className="tw-w-[32px] mx-1"
                    ></img>
                    {isEditingDiscNames === index ? (
                      <div className="tw-w-[calc(50%)]">
                        <input
                          type="text"
                          value={item.title}
                          onChange={(e) => {
                            data[index].title = e.target.value;
                            setData([...data]);
                          }}
                          placeholder="Choose disc title"
                          className="tw-text-md tw-p-2 tw-rounded-md tw-w-[calc(100%)]"
                        />
                      </div>
                    ) : (
                      <div className="tw-w-[calc(50%)] tw-bg-blue tw-p-2  flex justify-content-left text-left">
                        <span
                          onClick={() => handleEditDiscName(index)}
                          className="text-left mx-2"
                        >
                          {item.title}
                        </span>
                      </div>
                    )}
                    <div className="tw-w-[calc(50%)] flex justify-content-evenly ">
                      <div className="tw-cursor-pointer flex justify-center items-center w-30 h-30 tw-bg-blue tw-p-2">
                        {isEditingDiscNames === index ? (
                          <div onClick={() => handleSaveDiscName()}>Save</div>
                        ) : (
                          <div onClick={() => handleEditDiscName(index)}>
                            Edit
                          </div>
                        )}
                      </div>
                      <div
                        className="tw-cursor-pointer flex justify-center items-center w-30 h-30 tw-bg-blue tw-p-3"
                        onClick={() => moveItemUp(item_id)}
                      >
                        <UpOutlined />
                      </div>
                      <div
                        className="tw-cursor-pointer flex justify-center items-center w-30 h-30  tw-bg-blue tw-p-3"
                        onClick={() => moveItemDown(item_id)}
                      >
                        <DownOutlined />
                      </div>
                      <div
                        className="tw-cursor-pointer flex justify-center items-center w-30 h-30 tw-bg-blue tw-p-3"
                        onClick={() => {
                          data.splice(index, 1);
                          setData([...data]);
                        }}
                      >
                        <CloseOutlined />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-12 col-md-6 tw-w-25 flex  tw-items-start">
                  <label
                    htmlFor="trackUpload"
                    id="trackUploadLabel"
                    className="tw-w-25 flex tw-justify-start tw-items-start upload-image-setup p-0"
                  >
                    <input
                      type="file"
                      accept=".jpg"
                      name="track_imageURL"
                      id="trackUpload"
                      className="display-none w-25 inputfile inputfile-3 w-0.1 h-0.1 opacity-0 overflow-hidden absolute -z-1"
                      onChange={handleImageUpload}
                    />
                    {selectedImage ? (
                      <img
                        src={selectedImage}
                        className="w-25 align-middle border-none"
                        alt="Cover Art"
                      />
                    ) : (
                      <img
                        src={`${REACT_IMAGE_URL}/static/images/coverart-placeholder.svg`}
                        className="w-25 align-middle border-none"
                        alt="Cover Art"
                      />
                    )}
                  </label>
                </div>
              </div>

              <div className="tw-relative tw-text-start">
                {/* //  sm:tw-auto md:tw-auto lg:tw-w-[calc(40%)] xl:tw-w-[calc(40%)] */}

                <UploadTrack
                  handleTrackDelete={handleTrackDelete}
                  data={data}
                  discId={item.id}
                  setData={setData}
                />
              </div>
              <div className="tw-py-0 flex tw-text-center tw-mx-5">
                <div>
                  <Tracks
                    idsexist={item.id}
                    addExistingTrack={addExistingTrack}
                  />
                </div>
              </div>
            </div>
          );
        })}
      </div>
      <div className="col-12 p-4 text-center tw-w-full tw-flex tw-justify-center   border tw-relative tw-h-[200px]">
        <div className="relative inline-block border-3 tw-absolute">
          <img
            src={`${REACT_IMAGE_URL}/static/images/add_disk_bg.svg`}
            className="tw-w-[40%] align-middle border-none"
            alt="Add Disk"
          />
        </div>
        <div className="absolute inset-0 flex tw-items-center justify-center">
          <DefaultButton
            className="absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 text-center"
            onClick={() => {
              data.push({
                id: generateShortUUID(),
                title: "disc#" + (data.length + 1),
                tracks: [],
              });
              setData([...data]);
            }}
          >
            Add Disc
          </DefaultButton>
        </div>
      </div>
    </div>
  );
};

const generateShortUUID = (length = 6) => {
  const fullUUID = uuidv4();
  const shortUUID = fullUUID.replace(/-/g, "").substring(0, length);
  return shortUUID;
};
export default TabSelectTrack;
